/**
 * Toast イベント ID とデフォルトメッセージ
 * {placeholder} は showToast の第2引数で置換
 */

export const TOAST_DURATION_MS = 10000;

export const TOAST_VARIANTS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

export const TOAST_EVENTS = {
  'license.contract.success': {
    variant: 'success',
    message: '「{moduleName}」の契約が完了しました'
  },
  'license.recontract.success': {
    variant: 'success',
    message: '「{moduleName}」を再契約しました'
  },
  'license.cancel.success': {
    variant: 'success',
    message: '「{moduleName}」の解約を受け付けました'
  },
  'license.contract.error': {
    variant: 'error',
    message: '{message}'
  },
  'license.cancel.error': {
    variant: 'error',
    message: '{message}'
  },
  'billing.portal.return': {
    variant: 'info',
    message: '支払い情報を更新しました'
  },
  'billing.portal.error': {
    variant: 'error',
    message: '{message}'
  },
  'account.profile.success': {
    variant: 'success',
    message: 'プロフィールを更新しました'
  },
  'account.password.success': {
    variant: 'success',
    message: 'パスワードを変更しました'
  },
  'account.email-pref.success': {
    variant: 'success',
    message: '{message}'
  },
  'account.error': {
    variant: 'error',
    message: '{message}'
  },
  'clinic.update.success': {
    variant: 'success',
    message: 'クリニック情報を保存しました'
  },
  'clinic.update.error': {
    variant: 'error',
    message: '{message}'
  },
  'clinic.logo.error': {
    variant: 'error',
    message: '{message}'
  },
  'integrations.save.success': {
    variant: 'success',
    message: '連携を保存しました'
  },
  'integrations.save.error': {
    variant: 'error',
    message: '{message}'
  },
  'integrations.delete.success': {
    variant: 'success',
    message: '連携を解除しました。'
  },
  'integrations.delete.error': {
    variant: 'error',
    message: '{message}'
  },
  'user.create.success': {
    variant: 'success',
    message: 'ユーザーを追加しました'
  },
  'user.update.success': {
    variant: 'success',
    message: 'ユーザー情報を更新しました'
  },
  'user.delete.success': {
    variant: 'success',
    message: 'ユーザーを削除しました'
  },
  'user.toggle.success': {
    variant: 'success',
    message: '{message}'
  },
  'user.error': {
    variant: 'error',
    message: '{message}'
  },
  'invitation.generate.success': {
    variant: 'success',
    message: '招待コードを発行しました'
  },
  'invitation.register.success': {
    variant: 'success',
    message: '{message}'
  },
  'invitation.redeem.success': {
    variant: 'success',
    message: '{message}'
  },
  'invitation.error': {
    variant: 'error',
    message: '{message}'
  },
  'auth.login.success': {
    variant: 'success',
    message: 'ログインしました'
  },
  'auth.logout.success': {
    variant: 'info',
    message: 'ログアウトしました'
  },
  'auth.signup.success': {
    variant: 'success',
    message: 'アカウントの登録が完了しました'
  },
  'auth.error': {
    variant: 'error',
    message: '{message}'
  },
  'contact.success': {
    variant: 'success',
    message: 'お問い合わせを送信しました'
  },
  'contact.error': {
    variant: 'error',
    message: '{message}'
  },
  'clipboard.copy.success': {
    variant: 'info',
    message: 'コピーしました'
  },
  'beta.toggle': {
    variant: 'info',
    message: '{message}'
  },
  'generic.success': {
    variant: 'success',
    message: '{message}'
  },
  'generic.error': {
    variant: 'error',
    message: '{message}'
  }
};

export function interpolateMessage(template, params = {}) {
  if (!template) return '';
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    const value = params[key];
    return value != null && value !== '' ? String(value) : '';
  }).trim();
}
